import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowStepEditorModel, isTerminalStepIndex } from '../../models/flow-step-editor.model';
import { CatalogService } from '@services/data/catalog.service';

@Component({
  selector: 'app-flow-diagram',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flow-diagram.component.html',
  styleUrl: './flow-diagram.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FlowDiagramComponent {
  @Input() flows: FlowStepEditorModel[] = [];

  private catalogService = inject(CatalogService);

  /** El diagrama muestra el recorrido real: los pasos inactivos no entran. */
  visibleFlows(): FlowStepEditorModel[] {
    return (this.flows || []).filter((flow) => flow.isActive !== false);
  }

  isLastStep(index: number): boolean {
    return index === this.visibleFlows().length - 1;
  }

  isTerminalStep(index: number): boolean {
    return isTerminalStepIndex(this.visibleFlows().length, index);
  }

  isExtraordinaryActive(flow: FlowStepEditorModel): boolean {
    return flow.isExtraordinaryActive();
  }

  /** Etiqueta de estado para la pastilla BPM. */
  statusName(statusId: number | string | null | undefined, flow?: FlowStepEditorModel): string {
    if (flow?.status?.name) return flow.status.name;
    if (!statusId) return 'Sin estado';
    return this.catalogService.getStatusById(statusId as number)?.name
      ?? this.catalogService.statuses()?.find((s: any) => s.id === statusId || s.uuid === statusId)?.name
      ?? 'Sin estado';
  }

  /** Etiqueta de rol desde el catálogo. */
  roleLabel(roleName: string | null | undefined): string {
    if (!roleName) return 'Cualquier usuario';
    const role = this.catalogService.roles()?.find((r: any) => r.name === roleName);
    return role?.displayName || roleName;
  }

  documentTypeName(flow: FlowStepEditorModel): string {
    return flow.documentType?.name || flow.documentTypeSlug || '—';
  }
}
